import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=27897a14&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=27897a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27897a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27897a14')) {
      api.createRecord('27897a14', component.options)
    } else {
      api.reload('27897a14', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=27897a14&scoped=true&", function () {
      api.rerender('27897a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VgYzXslAgqWz/JS/comp/DateRangeExt.vue"
export default component.exports